var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 362,
    viewBox: "0 0 223 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 96.92L92.8601 95C92.8601 95 91.89 99.41 98.25 101.57L95.71 103.54C95.7 103.54 90.36 102.91 90 96.92Z",
    fill: "#F15A29",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 285.92L41.8601 284C41.8601 284 40.89 288.41 47.25 290.57L44.71 292.54C44.7 292.54 39.36 291.91 39 285.92Z",
    fill: "#F15A29",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.18 10.45L129 9.10999C129 9.10999 133.22 7.5 131.53 1L134.58 2.03998C134.57 2.04998 136.99 6.85001 132.18 10.45Z",
    fill: "#F15A29",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.18 190.45L113 189.11C113 189.11 117.22 187.5 115.53 181L118.58 182.04C118.57 182.05 120.99 186.85 116.18 190.45Z",
    fill: "#F15A29",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 193.92L3.86011 192C3.86011 192 2.89 196.41 9.25 198.57L6.71021 200.54C6.71021 200.54 1.37 199.92 1 193.92Z",
    fill: "#E6126A",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214 123.92L216.86 122C216.86 122 215.89 126.41 222.25 128.57L219.71 130.54C219.7 130.54 214.36 129.92 214 123.92Z",
    fill: "#E6126A",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 131.01L142 127.79C142 127.79 146.08 129.72 149.6 124L150.96 126.92C150.97 126.92 149.17 131.99 143.24 131.01Z",
    fill: "#7E3F97",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184 32.73L186.98 31C186.98 31 185.72 35.34 191.93 37.91L189.26 39.71C189.26 39.71 183.97 38.74 184 32.73Z",
    fill: "#7E3F97",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155 73.73L157.98 72C157.98 72 156.72 76.34 162.93 78.9L160.26 80.7C160.26 80.71 154.97 79.74 155 73.73Z",
    fill: "#7E3F97",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.21 10.5501L54.03 12.0802C54.03 12.0802 53.76 9.57015 50 9.55015L51 8.05015C51 8.05015 53.95 7.43015 55.21 10.5501Z",
    fill: "#E6126A",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.49 59.39L96 57.17C96 57.17 99.4201 57.93 101.1 53L102.63 54.98C102.63 54.98 102.14 59.12 97.49 59.39Z",
    fill: "#E6126A",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.21 114.55L51.03 116.08C51.03 116.08 50.76 113.57 47 113.55L48 112.05C48.01 112.05 50.95 111.43 52.21 114.55Z",
    fill: "#7E3F97",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.21 75.8301L9 73.1801C9 73.1801 13.49 73.6901 14.97 67.1401L17.2 69.4601C17.2 69.4701 17.14 74.8501 11.21 75.8301Z",
    fill: "#F15A29",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.21 360.69L114 358.04C114 358.04 118.49 358.55 119.97 352L122.2 354.32C122.2 354.32 122.14 359.7 116.21 360.69Z",
    fill: "#F15A29",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.5552d6e8980eacbe3dd812bcc7a3aee3.svg";
export { ForwardRef as ReactComponent };